const ENTITY_ID = 'OneTrust'

const isOneTrust = () => !!window.OneTrust

const getOneTrustCurrentConsents = () =>
  typeof window.OnetrustActiveGroups === 'string'
  || window.OnetrustActiveGroups instanceof String
    ? window.OnetrustActiveGroups.split(',').filter(n => n)
    : []

const getOneTrustChangeEventConsents = event => event.detail

const onOneTrustConsentChanged = (cb) => window.OneTrust.OnConsentChanged(event => {
  cb(getOneTrustChangeEventConsents(event))
})


const id = ENTITY_ID
const init = function(onChange) {
  if(!isOneTrust()) return false
  onChange(getOneTrustCurrentConsents())
  onOneTrustConsentChanged(onChange)
  return true
}

export { id, init }